import {ajaxHilo, getHoilUrl,getRequestUrl,ajax} from "../request";

export default {
  getTemplateActV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTemplate/config/list",1), data, {
      method
    });
  },

  getTempActCateV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTemplate/config/getCate",1), data, {
      method
    });
  },

  createTemplateActV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTemplate/config/",2), data, {
      method
    });
  },
  updateTemplateV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTemplate/config/",3), data, {
      method
    });
  },
  checkTemplate(data, method) {
    return ajax("post", getRequestUrl("/activity/checkTemplate"), data, {
      method
    });
  },

  getActListV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actRecord/list",1), data, {
      method
    });
  },

  createActV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actRecord",2), data, {
      method
    });
  },

  updateActV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actRecord",3), data, {
      method
    });
  },

  copyActV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actRecord/copy",2), data, {
      method
    });
  },

  getGiftID(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actGift/config/list",1), data, {
      method
    });
  },

  getActTaskV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTask/config/list",1), data, {
      method
    });
  },

  createActTaskV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTask/config/",2), data, {
      method
    });
  },

  updateActTaskV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTask/config/",3), data, {
      method
    });
  },

  delActTaskV2(data, method) {
    return ajaxHilo(
        "post",
        getHoilUrl(
            `/actMgr/v2/actTask/config/${data.activityId}/${data.taskId}`
            ,4),
        data,
        {
          method
        }
    );
  },

  copyActTaskV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actTask/config/copy",2), data, {
      method
    });
  },

  getTaskRewardV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actAward/config/list",1), data, {
      method
    });
  },

  createTaskRewardV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actAward/config",2), data, {
      method
    });
  },

  updateTaskRewardV2(data, method) {
    return ajaxHilo("post", getHoilUrl("/actMgr/v2/actAward/config",3), data, {
      method
    });
  },

  delTaskRewardV2(data, method) {
    return ajaxHilo(
        "post",
        getHoilUrl(
            `/actMgr/v2/actAward/config/${data.activityId}/${data.taskId}/${data.n}`
            ,4),
        data,
        {
          method
        }
    );
  },
}



// WEBPACK FOOTER //
// ./src/js/https/templateAct.js